import React, { useState } from "react";
import { Link } from "react-router-dom";
import towing from "../../assets/images/towing.svg";
import Whitelogo from "../../assets/images/White-logo.svg";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { APIURL } from "./../../redux/action/config";
import { useParams } from "react-router-dom";
import { ValidationResetPassword } from "../../utills/Validation";

const ChangePassword = () => {
  const { id } = useParams();
  const [activeLoader, setActiveLoader] = useState(false);
  const [btnStatus, setBtnStatus] = useState("");
  const currentYear = new Date().getFullYear();

  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-root">
        <ToastContainer autoClose={2000} />
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div
            className="d-flex flex-column flex-lg-row-auto bg-primary w-xl-600px positon-xl-relative banner-height"
            style={{ height: "100vh" }}
          >
            <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                <Link to="#" className="py-9 pt-lg-20">
                  <img alt="Logo" src={Whitelogo} className="h-40px" />
                </Link>
                <h1 className="fw-bolder text-white fs-2qx pb-5 pb-md-10">
                  Welcome to Roadside
                </h1>
                <p className="fw-bold fs-2 text-white">
                  Emergency Roadside Assistance for Every Bahamas Motorist
                </p>
              </div>
              <div
                className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
                style={{
                  backgroundImage: `url(${towing})`,
                }}
              ></div>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row-fluid py-10">
            <div className="d-flex flex-center flex-column flex-column-fluid">
              <div className="w-lg-500px p-10 p-lg-15 mx-auto w-100">
                <Formik
                  initialValues={{
                    password: "",
                    passwordConfirmation: "",
                  }}
                  validationSchema={ValidationResetPassword}
                  onSubmit={(values) => {
                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");

                    var raw = JSON.stringify({
                      password: values.password,
                    });

                    var requestOptions = {
                      method: "PATCH",
                      headers: myHeaders,
                      body: raw,
                      redirect: "follow",
                    };

                    fetch(
                      `${APIURL}/api/v1/users/resetPassword/${id}`,
                      requestOptions
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        if (result.status === "success") {
                          setActiveLoader(true);
                          setBtnStatus("disabled");
                          toast.success(result.message);
                          setTimeout(() => {
                            return (window.location.href = "/");
                          }, 1000);
                        } else {
                          toast.error(result.message);
                        }
                      })
                      .catch((error) => console.log("error", error));
                  }}
                >
                  {({
                    values,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                  }) => (
                    <form
                      className="form  w-100"
                      onSubmit={handleSubmit}
                      id="myForm"
                    >
                      <div className="text-center mb-10">
                        <h1 className="text-dark mb-3">Forgot Password ?</h1>
                        <div className="text-gray-400 fw-bold fs-4">
                          Reset Your Password
                        </div>
                      </div>
                      <div className="fv-row mb-10">
                        <label className="form-label fs-6 fw-bolder text-dark">
                          <span className="required">Password</span>
                        </label>
                        <input
                          type="text"
                          name="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Enter password"
                        />
                        {errors.password && touched.password ? (
                          <div className="text-danger mt-2">
                            {errors.password}
                          </div>
                        ) : null}
                      </div>
                      <div className="fv-row mb-10">
                        <label className="form-label fs-6 fw-bolder text-dark">
                          <span className="required">Confirm Password</span>
                        </label>
                        <input
                          type="text"
                          name="passwordConfirmation"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Enter password"
                        />
                        {errors.passwordConfirmation &&
                        touched.passwordConfirmation ? (
                          <div className="text-danger mt-2">
                            {errors.passwordConfirmation}
                          </div>
                        ) : null}
                      </div>
                      <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                        <button
                          id="kt_password_reset_submit"
                          onClick={handleSubmit}
                          className={`btn btn-lg btn-primary w-100 fw-bolder me-4 ${
                            values.password == "" ||
                            values.passwordConfirmation == ""
                              ? "disabled"
                              : btnStatus
                          }`}
                          type="button"
                        >
                          {activeLoader == true ? (
                            <div className="spinner-border w-80" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : (
                            <span className="indicator-label">Continue</span>
                          )}
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
              <div className="d-flex flex-center fw-bold fs-6">
                <p>{currentYear} © Copyright All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ChangePassword;
